<template>
    <modal
        :active="active"
        @closed="$emit('closed', true)"
        :title="title()"
        :large="true"
    >
        <div class="columns is-tablet">
            <form-field
                class="column"
                label="Underlokation af"
                inner-container-class="is-fullwidth"
                :error="error.parent_id"
            >
                <InputSelectSearch
                    v-model="parent"
                    :options="parentOptions"
                    label="full_name"
                    option-value-prop="id"
                    placeholder="Vælg..."
                    :filter="filterLocations"
                    :append-to-body="true"
                />
            </form-field>
        </div>

        <div class="columns is-tablet mb-2 mt-1">
            <form-field
                class="column"
                label="Lokation"
                :error="error.name"
            >
                <input-text
                    v-model="form.name"
                    :error="error.name"
                />
            </form-field>
        </div>

        <template v-slot:footer class="has-space-between">
            <div class="footer-spacer">
                <div>
                    <button class="button is-danger is-flex-left" @click="reset">Nulstil</button>
                    <button class="button is-default" @click="findItems">Find varer</button>
                    <button class="button is-default" @click="$emit('closed', true)">Annuller</button>
                    <button class="button is-primary" @click="submit">{{ saveButtonText }}</button>
                </div>

                <button class="button is-danger" @click="remove" v-if="isEdit">Slet</button>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import {FormField, InputText, InputSelectSearch} from '@elems/form'

export default {
    components: {
        Modal,
        FormField,
        InputText,
        InputSelectSearch
    },
    props: {
        active: Boolean,
        locationId: [Number, Boolean],
        locations: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            form: {
                name: '',
                parent_id: null,
            },
            parent: null,
            error: [],
        }
    },
    watch: {
        active() {
            scrollLock(this.active);
            if (!this.active) {
                this.reset()
            }
        },
        locationId() {
            this.reset()
        },
        parent() {
            this.form.parent_id = this.parent ? this.parent.id : null;
        },
    },
    computed: {
        parentOptions() {
            if (this.isEdit) {
                return this.locations.filter(location => location.id !== this.locationId);
            }
            return this.locations;
        },
        isEdit() {
            return this.locationId !== null
        },
        saveButtonText() {
            return this.isEdit ? 'Gem' : 'Opret'
        },
    },
    methods: {
        filterLocations(options, search) {
            const terms = search.toLocaleLowerCase().split(' ');
            return options.filter(option => {
                return terms.every(term => {
                    return option.full_name.toLocaleLowerCase().indexOf(term) > -1
                });
            });
        },
        title() {
            return this.isEdit ? 'Rediger lokation' : 'Opret lokation'
        },
        submit() {
            return this.isEdit ? this.update() : this.create()
        },
        create() {
            window.axios.post('/api/locations', this.form)
                .then(({ data }) => {
                    this.$emit('closed')
                    this.$emit('created', data)
                    this.$store.dispatch('addLocation', data)
                    this.$store.dispatch('setSuccess', 'Lokation blev oprettet')
                    this.reset()
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.error = error.response.data.errors
                    }
                })
        },
        update() {
            window.axios.put('/api/locations/' + this.locationId, this.form)
                .then(({ data }) => {
                    this.$emit('closed')
                    this.$store.dispatch('updateLocation', data)
                    this.$store.dispatch('setSuccess', 'Lokation blev opdateret')
                    this.reset()
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.error = error.response.data.errors
                    }
                })
        },
        reset() {
            if (this.isEdit) {
                const location = this.$store.getters.findLocation(this.locationId)
                this.form = { 
                    name: location.name,
                    parent_id: location.parent_id,
                }
                this.parent = location.parent
            } else {
                this.form = { 
                    name: '',
                    parent_id: null,
                }
                this.parent = null
            }
            this.error = []
        },
        async remove() {
            await window.axios.get('/api/locations/' + this.locationId + '/in-use')
                .then(({data}) => {
                    if (data) {
                        this.error = { name: ['Lokationen bruges på en eller flere varer og kan ikke slettes.']};
                    }
                })
                .catch(error => {
                    console.error(error);
                })

            if (Object.keys(this.error).length > 0) {
                return;
            }

            if (!confirm('Er du sikker på du vil slette ' + this.form.name + '?')) {
                return
            }

            window.axios.delete('/api/locations/' + this.locationId)
                .then(() => {
                    this.$emit('closed')
                    this.$store.dispatch('removeLocation', this.locationId)
                    this.$store.dispatch('setSuccess', 'Lokation blev slettet')
                })
                .catch(error => {
                    this.$store.dispatch('setError', 'Lokation kunne ikke slettes')
                })
        },
        findItems() {
            scrollLock(false);
            this.$router.push({
                name: 'item.index',
                query: {
                    location: this.locationId,
                },
            });
        },
    },
    created() {
        if (this.locationId) {
            this.reset()
        }
    },
}
</script>

<style lang="scss" scoped>
.footer-spacer {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
}

.customer-details {
    h4 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #bbb;
        margin-bottom: 25px;
        cursor: pointer;

        i {
            transition: transform .3s ease-in-out;
        }
    }

    .column {
        display: none;
    }

    &.open {
        h4 i {
            transform: rotate(.5turn);
        }

        .column {
            display: block;
        }
    }


}

.column {
    padding: 0 0.75rem;
}
</style>
